export const TOGGLE_SINGLE_COMPLETE = "TOGGLE_SINGLE_COMPLETE";
export const TOGGLE_DOUBLES_COMPLETE = "TOGGLE_DOUBLES_COMPLETE";
